import localDB from "./localDB";

let GLOBAL = require('./globals');

const BusinessHourData = {
    async get(res) {
        await fetch(`${GLOBAL.BASE_URL}store/business-hours`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },
    update(data, res) {
        fetch(`${GLOBAL.BASE_URL}store/business-hours`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => {
            res(responseData);
        }).catch(() => {
            res({update: false})
        });
    },
};

export default BusinessHourData;


// WEBPACK FOOTER //
// ./src/data/BusinessHoursData.js